module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vpelv5-367e4bd71a752f5a3f318249c075a37a.jpg";